import { Observable } from "rxjs";
import { FileAuthorizationRequest, FileAuthorizationResponse } from "../models/dataloadmanagement.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class DataloadmanagementService {
    constructor(private http: HttpClient) { }

    getFileAuthorizations(clientID: number, sortBy?: string, sortDir?: 'asc' | 'desc', skip = 0, count = 20): Observable<FileAuthorizationResponse> {
        const headers = new HttpHeaders({
        });
        const params = new HttpParams()
            .set('clientID', clientID.toString())
            .set('sortBy', sortBy ?? '')
            .set('sortDir', sortDir ?? '')
            .set('skip', skip.toString())
            .set('count', count.toString());
        const url = `${environment.apiUrl}data-load-management/`;
        return this.http.get<FileAuthorizationResponse>(url, { headers, params });
    }

    updateFileAuthorization(request: FileAuthorizationRequest): Observable<{ success: boolean }> {
        const headers = new HttpHeaders({
        });
        const url = `${environment.apiUrl}data-load-management`;
        return this.http.put<{ success: boolean }>(url, request, { headers });
    }
}